module.exports = __webpack_public_path__ + "img/tent2mountain.884d8b95.jpg";